export default function signOut(event) {
  if (event) {
    event.preventDefault();
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]');

  const form = document.createElement("form");
  form.method = "post";
  form.action = "/users/sign_out";
  form.style.display = "none";

  const methodInput = document.createElement("input");
  methodInput.type = "hidden";
  methodInput.name = "_method";
  methodInput.value = "delete";
  form.appendChild(methodInput);

  if (csrfToken) {
    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "authenticity_token";
    csrfInput.value = csrfToken.getAttribute("content");
    form.appendChild(csrfInput);
  }

  document.body.appendChild(form);
  form.submit();
}
